import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  FormControl,
  FormLabel,
  Input,
  ModalFooter,
  Button,
  Spinner,
  Text,
} from "@chakra-ui/react";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const SendTestModal = ({
                         isOpen,
                         onClose,
                         testDate,
                         setTestDate,
                         sendTestCampaign,
                         uploadingTemplate,
                         colorMode,
                       }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Select Date and Time for Test</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text>The test will be sent to the user directly.</Text>
          <FormControl mt={4}>
            <FormLabel>Select Date and Time</FormLabel>
            <ReactDatePicker
              selected={testDate}
              onChange={(date) => setTestDate(date)}
              showTimeSelect
              dateFormat="Pp"
              className="datepicker"
              wrapperClassName={
                colorMode === "light" ? "light-mode" : "dark-mode"
              }
              customInput={
                <Input
                  variant="filled"
                  bg={colorMode === "light" ? "gray.50" : "gray.700"}
                />
              }
            />
          </FormControl>
        </ModalBody>
        <ModalFooter>
          <Button variant="ghost" onClick={onClose}>
            Cancel
          </Button>
          <Button
            colorScheme="blue"
            onClick={sendTestCampaign}
            isDisabled={!testDate && !uploadingTemplate}
          >
            {uploadingTemplate ? <Spinner /> : "Send"}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default SendTestModal;
